import React, { useEffect, useState } from 'react';
import { checkConnection, fetchLinkedInAds } from '../lib/supabase';
import { LinkedInAd } from '../types/dataTypes';

interface ConnectionStatus {
  connected: boolean;
  schemaInitialized: boolean;
  error?: string;
  columns?: string[];
}

const TestConnection: React.FC = () => {
  const [status, setStatus] = useState<ConnectionStatus | null>(null);
  const [testAd, setTestAd] = useState<LinkedInAd | null>(null);

  useEffect(() => {
    const testConnection = async () => {
      console.log('Testing Supabase connection...');
      const result = await checkConnection();
      console.log('Connection test result:', result);
      setStatus(result);

      if (result.connected && result.schemaInitialized) {
        try {
          console.log('Fetching test ad...');
          const ads = await fetchLinkedInAds('431');
          console.log('Fetched ads:', ads);
          if (ads && ads.length > 0) {
            setTestAd(ads[0]);
          }
        } catch (err) {
          console.error('Error fetching test ad:', err);
        }
      }
    };

    testConnection();
  }, []);

  if (status === null || !status.connected) {
    return null;
  }

  return null;
};

export default TestConnection;